import { render } from "./SuggestionsGlobalNavigation.vue?vue&type=template&id=0b3c778a&scoped=true"
import script from "./SuggestionsGlobalNavigation.vue?vue&type=script&lang=js"
export * from "./SuggestionsGlobalNavigation.vue?vue&type=script&lang=js"

import "./SuggestionsGlobalNavigation.vue?vue&type=style&index=0&id=0b3c778a&lang=scss"
import "./SuggestionsGlobalNavigation.vue?vue&type=style&index=1&id=0b3c778a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3c778a"]])

export default __exports__